<template>
  <div id="app">
    <myheader></myheader>
    <div class="header-bj w-100 h-100 wow bounceInUp pc">
      <img class="w-100 h-100" :src="`http://www.waternaida.com/${banner}`" alt />
    </div>
    <div class="mb">
        <img class="w-100 mb" src="../../static/img/download/mb_download_banner.png" alt />
    </div>
    <div class="Breadcrumb">
      <el-breadcrumb class="Breadcrumb_item" separator-class="el-icon-arrow-right">
        <span>
          <i class="el-icon-minus"></i> Posición actual：
        </span>
        <el-breadcrumb-item :to="{ path: '/ESP' }">HOME</el-breadcrumb-item>
        <el-breadcrumb-item>DESCARGAS</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main w-100">
      <el-tabs class="main_menu" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="DOCUMENTO DESCARGAR" name="first">
          <div class="main_download1 w-100 row wow bounceInUp" data-wow-duration="1s">
            <div v-for="(item,index) in documentD" :key="index" class="main_download1_item col-lg-4 col-md-6 col-sm-12">
              <img class="w-100" :src="`http://www.waternaida.com/${documentD[index].image}`" alt />
              <div class="main_download1_items w-100">
                <span class="main_download1_item_txt">{{documentD[index].name}}</span>
                <a :href="`http://www.waternaida.com/${documentD[index].file}`" target="_blank">
                  <img class="main_download1_item_img" src="../img/download/下载.png" alt />
                </a>
              </div>
            </div>
            <el-pagination
              class="main_download1_pag"
              background
              layout="prev, pager, next"
              :total="0"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="VIDEO DESCARGAR" name="second">
          <div class="main_download1 w-100 row wow bounceInUp" data-wow-duration="1s">
            <div v-for="(item,index) in videoD" :key="index" class="main_download1_item videoD col-lg-4 col-md-6 col-sm-12">
                <a :href="`${videoD[index].file}`" target="_blank">
                    <div class="videoD-img">
                        <img class="w-100" :src="`http://www.waternaida.com/${videoD[index].image}`" alt />
                        <img class="videoD-icon" src="../../static/img/video.png" />
                    </div>
                    <div class="main_download1_items w-100">
                        <span class="main_download1_item_txt2">{{videoD[index].name}}</span>
                        <!-- <img class="main_download1_item_img" src="../img/download/下载.png" alt /> -->
                    </div>
                </a>
            </div>
            <el-pagination
              class="main_download1_pag"
              background
              layout="prev, pager, next"
              :total="0"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="VIDEOS OTROS" name="third">
          <el-collapse accordion class="pane wow bounceInUp" data-wow-duration="1s">
            <el-collapse-item v-for="(item,index) in download" :key="index">
              <template slot="title">{{download[index].name}}</template>
              <div class="pane_txt" v-html="download[index].http_content"></div>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
      </el-tabs>
    </div>
    <myfooter></myfooter>
  </div>
</template>
<style scoped>
.videoD a{
    color: inherit;
    display: block;
}
.videoD a:hover{
    text-decoration: none;
}
.videoD-img{
    position: relative;
}
.videoD-img:after{
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.4);
    transition: all 0.5s;
}
.videoD a:hover .videoD-img:after{
    background: rgba(0,0,0,0.6);
}
.videoD-icon{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    z-index: 1;
}
.main_menu {
  width: 80%;
  margin: 0 auto;
}
.pane_txt1 {
  margin-top: 20px;
}
.header-bj{
 margin-top: 40px;
}
.pane_txt {
  text-align: left;
  margin-left: 50px;
  margin-top: 2%;
}
.pane_txt > a {
  color: gray;
}
.pane > .el-collapse-item >>> .el-collapse-item__header {
  font-size: 30px;
  height: 100px;
  border-top: none;
  padding-left: 80px;
  padding-right: 40px;
  text-align: center;
}
.pane > .el-collapse-item >>> .is-active {
  color: red;
  font-size: 30px;
  background-color: rgb(203, 206, 209);
  height: 100px;
  border-top: none;
  padding-left: 80px;
  padding-right: 40px;
}
.pane >>> .el-collapse-item__arrow.is-active {
  opacity: 1;
  margin-top: -10px;
  height: 50px;
  width: 50px;
  padding: 0;
  color: gray;
}
.pane >>> .el-icon-arrow-right:before {
  content: "\E6E0";
  opacity: 1;
}
.pane_txt {
  padding-left: 30px;
  padding-right: 30px;
}
.main_download1_items {
  display: block;
  /* background-color: lightsalmon; */
}
.main_download1_item_txt2 {
  margin-top: 20px;
  display: block;
}
.main_download1_item_img {
  float: right;
}
.main_download1_pag {
  width: 100%;
  margin: 0 auto;
  margin-top: 40px;
}
.main_download1_item {
  margin-bottom: 50px;
}
.main_download1 {
  display: flex;
  margin-top: 50px;
}
.Breadcrumb {
  /* background: lightblue; */
  display: block;
  width: 80%;
  margin: 0 auto;
  /* float: right; */
  margin-bottom: 100px;
}
.Breadcrumb_item > span {
  float: left;
  display: block;
}
.Breadcrumb_item {
  float: right;
  /* background-color: lightcoral; */
}
@media screen and (max-width: 1200px) {
  .header-bj{
   margin-top: 0px;
  }
}
@media screen and (max-width: 992px){
  .pane >>> .el-collapse-item .el-collapse-item__header{
    font-size: 16px;
  }
  .Breadcrumb{
    display: inline-block;
    text-align:left;
  }
  .Breadcrumb_item{
    float: left;
  }
  .pane >>> .el-collapse-item .el-collapse-item__header {
    font-size: 16px;
    height: 100px;
    border-top: none;
    padding-left: 0px;
    padding-right: 0px;
    text-align: left;
  }
  .pane_txt {
    padding-left: 0px;
    padding-right: 0px;
    margin-left: 0px;
  }
}
@media screen and (max-width: 576px) {
  .main_download1_item {
    -webkit-box-flex: 0;
    flex: 0 0 50%;
    max-width: 50%;
  }
  .pane >>> .el-collapse-item .el-collapse-item__header{
    font-size: 10px;
    line-height: 1;
  }
}
</style>
<script>
import myfooter from "./zzj/footer_ESP";
import myheader from "./zzj/header_ESP";
import WOW from "wowjs";
export default {
  data() {
    return {
      activeName: "first",
      download: [],
      documentD: [],
      videoD: [],
      banner: []
    };
  },
  components: {
    myfooter: myfooter,
    myheader: myheader
  },
  methods: {
    handleClick(key, keyPath) {
      console.log(key, keyPath);
    }
  },
  created() {
    this.axios
      .get("/api/down/downlist?classifyID=26&page=1&perNum=10&language=2")
      .then(res => {
        this.download = res.data.downList;
        console.log(this.download);
      });

      this.axios
      .get("/api/down/downlist?classifyID=24&page=1&perNum=10&language=2")
      .then(res => {
        this.documentD = res.data.downList;
        console.log(this.documentD);
      });

      this.axios
      .get("/api/down/downlist?classifyID=25&page=1&perNum=100&language=2")
      .then(res => {
        this.videoD = res.data.downList;
        console.log(this.videoD);
      });

    this.axios
      .get("/api/banner/index?categoryID=19&language=1")
      .then(res => {
        this.banner = res.data.imgList[0].image;
        console.log(this.banner);
      })
      .catch(err => {
        console.log(err);
      });
  },
  mounted() {
    let wow = new WOW.WOW({
      boxClass: "wow",
      animateClass: "animated",
      mobile: true,
      live: true
    });
    wow.init();
  }
};
</script>


// WEBPACK FOOTER //
// src/components/download_ESP.vue